module.exports = __webpack_public_path__ + "img/icon_wxz_c.ece83843.png";